import { Text } from "@radix-ui/themes";

export function About() {
  return (
    <Text size="8" weight="bold">
      This is the about page
    </Text>
  );
}
